<template>
  <div class="unitContainer" v-if="unit">
    <v-layout row wrap>
      <v-flex v-if="unit.rooms" v-for="(room, index) of unitRooms" :key="index" :class="unitClassList" pa-1>
        <room-tile class="roomTile" :is-body-visible="true" :room="room" :unit="unit"></room-tile>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';

import appSettings from '../appSettings';

import BedBoardUtils from '../bedBoardUtils';
import RoomTile from './RoomTile.vue';

export default {
  name: 'Unit',
  data() {
    return {};
  },

  components: {
    'room-tile': RoomTile
  },
  computed: {
    unit() {
      if (this.$store.getters.selectedUnit) {
        this.$log.debug(`[${moment().format(appSettings.logDateFormat)}] SelectedUnit: ${this.$store.getters.selectedUnit.name}`);
      }
      return this.$store.getters.selectedUnit;
    },
    unitClassList() {
      return `xs${this.$store.getters.roomSize}`;
    },
    unitRooms() {
      BedBoardUtils.sortRooms(this.unit.rooms);
      return this.unit.rooms;
    }
  }
};
</script>

<style lang="scss">
.roomTile {
  background-color: #ffffff;
  // height: 100%;
}
.unitContainer {
  background-color: #ebebeb;
  height: 100%;
  padding: 5px;
}
</style>
